module.exports = __webpack_public_path__ + "img/phone.2bccd6d2.svg";